module.exports = __webpack_public_path__ + "img/ic_qrcode_tw.890fd10.png";